import { Box } from '@material-ui/core';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '@routes/CompanyInfo/context/CompanyInfoContext';
import React, { useContext } from 'react';
import CompanyBlogPreviewPresenter from './CompanyBlogPreviewPresenter';

const ComapnyBlogPreviewContainer = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );
  if (!context) {
    return null;
  }
  const { partnerInfo } = context;

  return (
    <Box
      marginTop={'12px'}
      display={'flex'}
      flexDirection={'column'}
      gridGap={10}
    >
      {(partnerInfo?.promotionModels ?? []).map(({ capaBlogLink }) => (
        <CompanyBlogPreviewPresenter
          key={capaBlogLink}
          blogURL={capaBlogLink}
        />
      ))}
    </Box>
  );
};

export default ComapnyBlogPreviewContainer;
